<script lang="ts">
    import JewelGridItem from "./JewelGridItem.svelte";
    import {createEventDispatcher} from "svelte";

    export interface IJewelGridItem{
        icon: string,
        id: string,
        selected?: boolean,
    }
    export let title = "Title"
    export let items: IJewelGridItem[] = []
    export let vertical = false
    export let selected: string = items.find(v=>v.selected).id;
    let clazz = "";
    export {clazz as class}
    const dispatch = createEventDispatcher();

</script>

<div class="bg-transparent {vertical?'h-full w-auto':'w-full h-auto'} flex flex-col items-stretch {clazz}">
    {#if (title && title.length)}
    <div class="bg-white rounded mx-3 px-1.5 py-0.5">
        {title}
    </div>
    {/if}
    <div class="bg-transparent h-auto flex flex-{vertical ? 'col' : 'row'} flex-wrap mx-2 my-2">
        {#each items as item}
            <JewelGridItem class="w-12 h-12 m-1 p-2" selected="{item.selected}" icon="{item.icon}" on:click={(e)=>{
                //if(selected && selected.length)
                    items.forEach(v=>v.selected=false);

                item.selected = true;
                e.jid=item.id;
                selected = item.id
                dispatch('select',e);
            }}/>
        {/each}
    </div>
</div>

<style lang="postcss">
</style>
